import React, { ChangeEvent, useState, useEffect, useRef } from "react";
import { Form, Button } from 'react-bootstrap';
import { Container, Tabelas1, MCol, MRow } from './styles';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import api from '../../../services/api';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { useToast } from '../../../hooks/toast';
import { FiXCircle } from 'react-icons/fi';
import { FaBarcode, FaFileSignature, FaCloud, FaInfoCircle } from 'react-icons/fa';
import { CgNotes } from 'react-icons/cg';
import NumberFormat from "react-number-format";
import FormHelperText from '@mui/material/FormHelperText';
import Modal from '@mui/material/Modal';
import cep from 'cep-promise';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Seguradoras } from '../../../interfaces/seguradoras';
import { SeguroGrupos } from '../../../interfaces/seguroGrupos';
import { TemplateVenda } from '../../../interfaces/templateVenda';
import { grupoEmFormacao } from '../../../utils/grupoEmFormacao';
import { NumeroAssembleia } from "../../../interfaces/assembleias";
import { useHistory } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { Col, Row } from "../styles";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

const numero = require('numero-por-extenso');

function NumberFormatCustom(props: any) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      //decimalSeparator={","}

      prefix={"R$ "}
      format={currencyFormatter}
    />
  );
}

function currencyFormatter(value: any) {
  if (!Number(value)) return "";

  const amount = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(value / 100);

  return amount

}

const style = {
  // position: 'absolute' as 'absolute',
  overflow: 'scroll',
  // overflowX: 'hidden',
  // top: '50%',
  // left: '50%',
  // transform: 'translate(-50%, -50%)',
  alignSelf: 'center',
  maxWidth: 800,
  with: '100%',
  maxHeight: 600,
  bgcolor: 'background.paper',
  //border: '2px solid #000',
  boxShadow: 2,
  p: 1,

  header: {
    padding: '12px 0',
    borderBottom: '1px solid darkgrey'
  },
  content: {
    padding: 12,
    overflow: 'scroll'
  }
};



// nome do layout sem diferenca de maiusculas, espacos ou .docx repetido (ex.: .docx.docx),
// para tratar como o mesmo template os enviados ao D4Sign com nome duplicado
function normalizarNomeTemplate(nome: string) {
  return (nome || '').trim().toUpperCase().replace(/(\.DOCX)+$/, '')
}

export function Etapa7Seguro(props: any) {

  const { addToast } = useToast();
  const testRef = useRef<HTMLDivElement>(null);
  const divAlto = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const { DadosVenda, setAlteraDados, setAlteraPagina } = props
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [recibo, setRecibo] = useState('');
  const [seguros, setSeguros] = useState<Seguradoras[]>([]);
  const [seguroGrupo, setSeguroGrupo] = useState<SeguroGrupos[]>([]);
  const [assembleia, setAssembleia] = useState<NumeroAssembleia[]>([]);
  const [tempVenda, setTempVenda] = useState<TemplateVenda[]>([])
  const [nomeCompleto, setNomeCompleto] = useState('')
  const [idTemplate, setIdTemplate] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [meses, setMeses] = useState<number>(0)
  const [btnProximo, setBtnProximo] = useState<boolean>(true)

  function calcularMesesDesdeNascimento(dataNascimento: string) {
    // Divide a string e extrai dia, mês e ano
    const [dia, mes, ano] = dataNascimento.split('/').map(Number);

    // Cria o objeto Date no formato correto (mês em JavaScript começa do zero)
    const nascimento = new Date(ano, mes - 1, dia);
    const hoje = new Date();

    let anos = hoje.getFullYear() - nascimento.getFullYear();
    let meses = hoje.getMonth() - nascimento.getMonth();
    let totalMeses = anos * 12 + meses;

    // Ajuste caso o dia atual ainda não tenha atingido o dia do nascimento
    if (hoje.getDate() < nascimento.getDate()) {
      totalMeses--;
    }

    setMeses(totalMeses);
    console.log(totalMeses)
  }

  useEffect(() => {
    segurosTodos()
    segurosGrupo()
    numeroAssembleia()
    atualizarEBuscarTemplates()
    calcularMesesDesdeNascimento(DadosVenda.dataNascimentoF || "")
  }, [])

  useEffect(() => {
    // .docx e .docx.docx com o mesmo nome sao o mesmo layout; entre eles vale sempre o mais recente (maior id)
    const templatesComMesmoNome = tempVenda.filter(item => normalizarNomeTemplate(item.nome) === normalizarNomeTemplate(nomeCompleto))
    const idObjeto = templatesComMesmoNome.length > 0
      ? templatesComMesmoNome.reduce((maisRecente, atual) => atual.id > maisRecente.id ? atual : maisRecente)
      : undefined

      console.log('cheg temp')
      console.log(tempVenda)
      console.log(templatesComMesmoNome)
      console.log(idObjeto)
    if (DadosVenda.contratarSeguro === 1) {


      const seguroG = seguroGrupo.find(item => item.codigoGrupo === DadosVenda.grupo)
      const percSeg = seguros.find(item => item.codigoSeguradora === seguroG?.codigoSeguradora)
      let percF: string = ""
      if (percSeg !== undefined) {
        percF = percSeg.percentualSegVida.toString() + "%"
      }

      var total = DadosVenda.valorParcelaComSeguro + DadosVenda.valorAdesao
      console.log(DadosVenda.valorParcelaComSeguro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))

      setAlteraDados({
        ...DadosVenda,
        reciboPrimeiraParcela: DadosVenda.valorParcelaComSeguro * 100,
        reciboPrimeiraParcelaFormatado: DadosVenda.valorParcelaComSeguro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        valorTotal: total,
        valorTotalF: total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        valorTotalExtenso: numero.porExtenso((total > 0 ? total : 0), numero.estilo.monetario).toUpperCase(),
        segVS: "X",
        segVN: percF,
        template: idObjeto?.idD4Sign,
        nomeCompletoTemplate: nomeCompleto

      })
    } else {
      setAlteraDados({ ...DadosVenda, template: idObjeto?.idD4Sign, nomeCompletoTemplate: nomeCompleto })
    }
  }, [nomeCompleto, tempVenda])

  async function segurosTodos() {
    const { data } = await api.get('/v1/seguradoras')
    setSeguros(data)
  }

  async function numeroAssembleia() {
    const { data } = await api.get('/v1/assembleias')
    setAssembleia(data)
  }

  async function segurosGrupo() {
    const { data } = await api.get('/v1/grupos-seguradora')
    setSeguroGrupo(data)
  }

  async function buscarTemplates() {
    const { data } = await api.get('/v1/templates')
    console.log('cheooo')
    console.log(data)
    setTempVenda(data)
  }

  async function atualizarEBuscarTemplates() {
    try {
      await api.post('/v2/templates/atualizar')
    } catch (err) {
      console.log(err)
      addToast({
        type: 'error',
        title: 'Templates desatualizados',
        description: 'Não foi possível atualizar os templates do D4Sign. O contrato pode não ser gerado; informe ao TI do consórcio!'
      })
    }
    buscarTemplates()
  }

  function adicionaZero(numero: number) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value)
    console.log(e.target.name)
    let valorFloat = parseFloat(e.target.value)
    if (e.target.name === "cpfBeneficiario") {
      let resultado = e.target.value.replaceAll("_", "").replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
      setAlteraDados({ ...DadosVenda, [e.target.name]: e.target.value.toUpperCase(), cpfBeneficiarioFormatado: resultado })
    } else if (e.target.name === "reciboAdesao" || e.target.name === "reciboPrimeiraParcela") {
      let resultado = parseFloat(e.target.value)
      let total = 0
      console.log(resultado / 100)
      let campo = e.target.name + "Formatado"
      if (e.target.name === "reciboAdesao") {
        total = (valorFloat + parseFloat(DadosVenda.reciboPrimeiraParcela)) / 100
        console.log('total :' + total)
      } else {
        total = (valorFloat + parseFloat(DadosVenda.reciboAdesao)) / 100
        console.log('total' + total)
      }
      setAlteraDados({
        ...DadosVenda, [e.target.name]: resultado,
        [campo]: (resultado / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        valorTotal: total,
        valorTotalF: total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        valorTotalExtenso: numero.porExtenso((total > 0 ? total : 0), numero.estilo.monetario).toUpperCase()
      })
    } else if (e.target.name === "cepBeneficiario") {
      let resultado = e.target.value.replaceAll("_", "").replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
      setAlteraDados({ ...DadosVenda, [e.target.name]: e.target.value })
      buscaCep(resultado)
    } else {
      setAlteraDados({ ...DadosVenda, [e.target.name]: e.target.value.toUpperCase() })
    }
  };

  const handleChangeInput2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAlteraDados({ ...DadosVenda, emailGeral: e.target.value.toUpperCase(), [e.target.name]: e.target.value.toUpperCase() })

  };


  useEffect(() => {
    rolar();
  }, [recibo])

  useEffect(() => {
    habilitaProximo()
  }, [DadosVenda])

  function rolar() {
    if (DadosVenda.tipoPagamento === "RECIBO") {
      if (testRef.current) {
        testRef.current.scrollIntoView()
      }
    } else {
      if (divAlto.current) {
        divAlto.current.scrollIntoView()
      }
    }
  }

  function rolagemFinal() {
    if (testRef.current) {
      console.log(DadosVenda.tipoPagamento)
      testRef.current.scrollIntoView()
      console.log(testRef)
    }
  }

  function rolagemCima() {
    if (divAlto.current) {
      divAlto.current.scrollIntoView()
      console.log(divAlto)
    }
  }

  function formatData(x: string) {
    let dataAss = new Date(x)
    let DataFormatada = ((adicionaZero(dataAss.getDate() + 1)) + "/" + (adicionaZero(dataAss.getMonth() + 1)) + "/" + (adicionaZero(dataAss.getFullYear())))
    return (DataFormatada)
  }

  async function handleChangeCheckPessoa(e: ChangeEvent<HTMLInputElement>) {
    if (parseInt(e.target.value) === 1) {
      let valorPremio = 0
      let taxaSeguro = 0
      const seguroG = seguroGrupo.find(item => item.codigoGrupo === parseInt(DadosVenda.grupo))
      const percSeg = seguros.find(item => item.codigoSeguradora === seguroG?.codigoSeguradora)
      let valorCreditoTaxa = DadosVenda.valorCredito / 100 * DadosVenda.taxaAdministracao + DadosVenda.valorCredito
      if (percSeg) {
        valorPremio = valorCreditoTaxa / 100 * percSeg.percentualSegVida
        taxaSeguro = percSeg.percentualSegVida
      }

      console.log(DadosVenda.valorCredito)
      console.log(DadosVenda.taxaAdministracao)
      console.log(valorCreditoTaxa)
      console.log(valorPremio)

      console.log(valorCreditoTaxa)
      console.log(valorPremio)

      let capitalSeguradoMorte: string = valorCreditoTaxa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      let capitalSeguradoInvalidez: string = valorCreditoTaxa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      let premioEstimadoMorte: string = valorPremio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      let premioEstimadoInvalidez: string = valorPremio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

      let percF: string = ""
      if (percSeg !== undefined) {
        percF = percSeg.percentualSegVida.toString() + "%"
      }

      var total = DadosVenda.valorParcelaComSeguro + DadosVenda.valorAdesao

      setAlteraDados({
        ...DadosVenda,
        [e.target.name]: parseInt(e.target.value),
        reciboPrimeiraParcela: DadosVenda.valorParcelaComSeguro * 100,
        reciboPrimeiraParcelaFormatado: DadosVenda.valorParcelaComSeguro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        valorTotal: total,
        valorTotalF: total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        valorTotalExtenso: numero.porExtenso((total > 0 ? total : 0), numero.estilo.monetario).toUpperCase(),
        segVS: "X",
        segVN: percF,
        capitalSeguradoMorte,
        capitalSeguradoInvalidez,
        premioEstimadoMorte,
        premioEstimadoInvalidez,
        taxaSeguro
      })
    } else {
      var total = DadosVenda.valorParcela + DadosVenda.valorAdesao

      setAlteraDados({
        ...DadosVenda,
        [e.target.name]: parseInt(e.target.value),
        reciboPrimeiraParcela: DadosVenda.valorParcela * 100,
        reciboPrimeiraParcelaFormatado: DadosVenda.valorParcela.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        valorTotal: total,
        valorTotalF: total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        valorTotalExtenso: numero.porExtenso((total > 0 ? total : 0), numero.estilo.monetario).toUpperCase(),
        // sem seguro: segVS ("X" = optante) fica vazio
        segVS: "",
        segVN: "--"
      })
    }


  }

  //segueeee
  // terminou

  function handleChangeCheck(e: ChangeEvent<HTMLInputElement>) {
    setAlteraDados({ ...DadosVenda, [e.target.name]: e.target.value })
    console.log(e.target.name, e.target.value)

  }





  // monta o nome do layout do contrato no D4Sign com todas as opcoes da venda,
  // independente da ordem em que pagamento e assinatura foram escolhidos
  function montarNomeTemplate(pagamento: string | undefined, assinatura: string | undefined) {
    let nome = 'CG_'

    if (DadosVenda.pessoa === 'juridica') {
      nome += 'PJ_'
    } else {
      nome += 'PF_'
    }

    if (DadosVenda.contratarSeguro === 1) {
      DadosVenda.idadeNumber > 73 ? nome += 'SEGN73_' : nome += 'SEGN_'
    }

    if (DadosVenda.reducao > 0) {
      nome += 'RED_'
    }

    if (DadosVenda.termos > 0) {
      nome += 'TER_'
    }

    if (pagamento === 'RECIBO') {
      nome += 'REC_'
    }

    if (assinatura === 'MANUAL') {
      nome += 'AM_'
    }

    // grupos em formacao (69, que a etapa 1 troca por "EM FORMAÇÃO") usam os layouts proprios no D4Sign, com sufixo _285
    if (grupoEmFormacao(DadosVenda.grupo)) {
      nome += '285_'
    }

    return nome.substring(0, nome.length - 1) + '.docx'
  }

  const tipoPagamento = async (tipo: string) => {

    if (tipo === 'RECIBO') {
      rolagemFinal()
    } else {
      rolagemCima()
    }

    setNomeCompleto(montarNomeTemplate(tipo, DadosVenda.tipoAssinatura));
    setRecibo(tipo)
    setAlteraDados({
      ...DadosVenda,
      tipoPagamento: tipo,
      indenizarLegislacao: 0,
    })
  }

  const tipoAssinatura = async (tipoAssinatura: string) => {
    setNomeCompleto(montarNomeTemplate(DadosVenda.tipoPagamento, tipoAssinatura));

    setAlteraDados({
      ...DadosVenda,
      tipoAssinatura: tipoAssinatura,
      indenizarLegislacao: 0,
    })
  }

  async function buscaCep(x: string) {
    if (x.length === 8) {
      try {
        let resultado = await cep(x)
        console.log(resultado.street)
        if (resultado.street) {
          setAlteraDados({
            ...DadosVenda,
            cepBeneficiario: x,
            enderecoBeneficiario: resultado.street.toUpperCase(),
            bairroBeneficiario: resultado.neighborhood.toUpperCase(),
            cidadeBeneficiario: resultado.city.toUpperCase(),
            estadoBeneficiario: resultado.state.toUpperCase(),
          })
        } else {
          addToast({
            type: 'info',
            title: 'Cep não encontrato!',
            description: 'Não encontramos este cep na base de dados!'
          });
          setAlteraDados({
            ...DadosVenda,
            cep: x,
            endereco: "",
            bairro: "",
            cidade: "",
            estado: "",
          })
        }
      } catch (err) {
        addToast({
          type: 'info',
          title: 'Cep não encontrato!',
          description: 'Não encontramos este cep na base de dados!'
        });
        setAlteraDados({
          ...DadosVenda,
          cep: x,
          endereco: "",
          bairro: "",
          cidade: "",
          estado: "",
        })
      }
    }
  }

  async function passaFase6() {
    const tudo = JSON.stringify(DadosVenda)
    if (DadosVenda?.id > 0) {
      const response = await api.put(`v1/pre-vendas/${DadosVenda.id}`, {
        idVendedor: DadosVenda.idVendedor,
        idTabela: DadosVenda.idTabela,
        documento: DadosVenda.documento,
        dataCriacao: DadosVenda.dataAdesao,
        etapa: 7,
        conteudo: tudo,
        dataExportacao: DadosVenda.dataAdesao,
        status: "CONCLUIDO",
        posVenda: "PENDENTE",
      })

      if (response.status === 200) {
        setAlteraDados({
          ...DadosVenda,
          id: response.data[0].id,

        })
      }
    } else {
      const response = await api.post(`v1/pre-vendas`, {
        idVendedor: DadosVenda.idVendedor,
        idTabela: DadosVenda.idTabela,
        documento: DadosVenda.documento,
        dataCriacao: DadosVenda.dataAdesao,
        etapa: 7,
        conteudo: tudo,
        dataExportacao: DadosVenda.dataAdesao,
        status: "CONCLUIDO",
        posVenda: "PENDENTE",

      })

      if (response.status === 201) {
        setAlteraDados({
          ...DadosVenda,
          id: response.data[0].id,

        })
      }
    }
  }

  async function efetivarVenda() {
    if (!DadosVenda.template) {
      addToast({
        type: 'error',
        title: 'Contrato não encontrado',
        description: `Não existe template no D4Sign para o layout ${DadosVenda.nomeCompletoTemplate || nomeCompleto || '(não definido)'}. Informe ao TI do consórcio!`
      })
      return
    }
    if (DadosVenda.codB === 0) {
      addToast({
        type: 'error',
        title: 'Erro bem selecionado',
        description: 'Ao retornar a primeira pagina, por favor selecione o bem novamente!'
      });
      setAlteraPagina(0)
      return
    }

    if (!DadosVenda.idVendedor) {
      addToast({
        type: 'error',
        title: 'Erro vendedor selecionado',
        description: 'Ao retornar a primeira pagina, por favor selecione o vendedor novamente!'
      });
      setAlteraPagina(0)
      return
    }


    if (DadosVenda.idPreVenda === 0) {
      DadosVenda.idPrevenda = DadosVenda.id
    }

    if (!DadosVenda.email1) {
      if (DadosVenda.email2) {
        DadosVenda.email1 = DadosVenda.email2
      } else if (DadosVenda.email3) {
        DadosVenda.email1 = DadosVenda.email3
      } else if (DadosVenda.email4) {
        DadosVenda.email1 = DadosVenda.email4
      } else {
        DadosVenda.email1 = 'bruno@consorciogroscon.com.br';

        addToast({
          type: 'success',
          title: 'Aguarde',
          description: 'Estamos gerando a venda!'
        });
      }
    }
    setCarregando(true)
    passaFase6()
    addToast({
      type: 'success',
      title: 'Aguarde',
      description: 'Estamos gerando a venda!'
    });
    const response = await api.post(`v1/vendas`, DadosVenda)
    console.log(response.data)

    if (response.status === 201 || response.status === 504 || response.status === 200) {
      if (response.data.urlBoleto)
        window.open(response.data.urlBoleto, '_blank');

      addToast({
        type: 'success',
        title: 'Venda Realizada',
        description: 'Parabéns venda realizada com sucesso!'
      });

      history.push(`/consultaContrato`)
    }
  }

  function abrirModal() {
    setOpen(true)
    let grupo = DadosVenda.grupo;
    console.log(grupo)
    if (grupo === "69")
      grupo = "EM FORMAÇÃO"


    console.log(grupo)
    console.log(assembleia)
    // a etapa 1 grava o grupo 69 como "EM FORMAÇÃO"; a assembleia e buscada pelo codigo real para calcular os termos
    const codigoGrupo = grupoEmFormacao(DadosVenda.grupo) ? '69' : String(DadosVenda.grupo)
    const numAss = assembleia.find(item => item.codigoGrupo.toString() === codigoGrupo && item.dataAssembleia === DadosVenda.primeiraAssembleia)
    console.log(numAss)
    if (numAss !== undefined) {
      console.log(DadosVenda.prazo)
      console.log(DadosVenda.planoBasico)
      console.log(numAss.numeroAssembleia)
      const termo = (DadosVenda.prazo) - (DadosVenda.planoBasico - numAss.numeroAssembleia + 1)
      setAlteraDados({
        ...DadosVenda,
        termos: termo,
        grupo: grupo,
        numAssembleiaAtual: numAss.numeroAssembleia
      })
    }
  }

  function habilitaProximo() {

    if (DadosVenda.contratarSeguro === 0) {
      setBtnProximo(false)
      return
    }
    else {
      setBtnProximo(true)
    }

    if (
      DadosVenda.d1 === "" &&
      DadosVenda.d2 === "" &&
      DadosVenda.d3 === "" &&
      DadosVenda.d4 === "" &&
      DadosVenda.d5 === "" &&
      DadosVenda.d6 === "" &&
      DadosVenda.d7 === ""
    ) {
      setBtnProximo(true)
      return
    }
    if (
      (DadosVenda.d1 === "S" ? true : (DadosVenda.d1 === "N" && DadosVenda.d1Justificativa.length > 0) ? true : false) &&
      (DadosVenda.d2 === "N" ? true : (DadosVenda.d2 === "S" && DadosVenda.d2Justificativa.length > 0) ? true : false) &&
      (DadosVenda.d3 === "N" ? true : (DadosVenda.d3 === "S" && DadosVenda.d3Justificativa.length > 0) ? true : false) &&
      (DadosVenda.d4 === "N" ? true : (DadosVenda.d4 === "S" && DadosVenda.d4Justificativa.length > 0) ? true : false) &&
      (DadosVenda.d5 === "N" ? true : (DadosVenda.d5 === "S" && DadosVenda.d5Justificativa.length > 0) ? true : false) &&
      (DadosVenda.d6 === "N" ? true : (DadosVenda.d6 === "S" && DadosVenda.d6Justificativa.length > 0) ? true : false) &&
      (DadosVenda.d7 === "N" ? true : (DadosVenda.d7 === "S" && DadosVenda.d7Justificativa.length > 0) ? true : false)
    ) {

      setBtnProximo(false)
      return
    } else {
      setBtnProximo(true)
    }
  }


  return (
    <>
      <Container>
       
      <Row between>
          <Col>
            <div>Deseja contratar seguro prestamista? <Tooltip style={{margin: '0px', color: '#133483', width: '35px', height: '35px'}} 
            title={<div>
              - Seguradora: HDI;<br />
              - Cobertura: Invalidez permanente por acidente ou morte;<br />
              - Capital segurado: Saldo devedor da cota.<br />
            </div>


            } placement="top"><IconButton><FaInfoCircle /></IconButton></Tooltip> </div>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="contratarSeguro"
              className="tipoPessoaRadio"
              onChange={handleChangeCheckPessoa}
              value={DadosVenda.contratarSeguro}
            >
              <Row>
                <Col>
                  <FormControlLabel disabled={(meses + DadosVenda.prazo) > 900 ? true : false} value="1" aria-label="teste" control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Sim" />
                  <FormHelperText style={{ marginTop: 10, marginRight: 20 }}>(Adesão: {DadosVenda.valorAdesaoFormatado} + Parcela: {DadosVenda.valorParcelaComSeguroFormatado})</FormHelperText>

                </Col>
                <Col>
                  <FormControlLabel value="0" control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Não" />
                  <FormHelperText style={{ marginTop: 10, marginRight: 20 }}>((Adesão: {DadosVenda.valorAdesaoFormatado}  + Parcela: {DadosVenda.valorParcelaFormatado})</FormHelperText>

                </Col>
              </Row>

            </RadioGroup>
          </Col>
        </Row>
        <Row>
          {(meses + DadosVenda.prazo) > 900 ?
            <>
              <Stack sx={{ width: '100%' }} spacing={2} style={{ marginLeft: "-20px" }}>
                <Alert severity="error" style={{ color: "red" }}>Idade excede 75 anos ao final do plano não é possível cadastrar seguro!</Alert>
              </Stack>
            </> :

            ""}

        </Row>
        {DadosVenda.contratarSeguro === 1 ? /*<>
          <Stack sx={{ width: '100%' }} spacing={2} style={{ marginLeft: "-20px" }}>
            <Alert severity="success" style={{ color: "green" }}>Preencher manualmente formulário de seguro e encaminhar para administradora!</Alert>
          </Stack>
        </>
         <Row className="row-inputs">
          <Col min={'140px'} max={'100%'}>
          <div className="inputNovo">
                        <FormControl className="inputNovo" variant="standard" style={{ marginTop: 9 }} >
                          <TextField
                            InputLabelProps={{ shrink: DadosVenda.sequenciaAgrupamento > 0 ? true : false }}
                            className='inputNovo'
                            id="standard-required"
                            label="Beneficiário 1"
                            variant="standard"
                            name='nomePrincipal'
                            value={DadosVenda.documentoFormatado}
                          />
                        </FormControl>
                      </div>
          </Col>
          <Col min={'140px'} max={'100%'}>
          <div className="inputNovo">
                        <FormControl className="inputNovo" variant="standard" style={{ marginTop: 9 }} >
                          <TextField
                            InputLabelProps={{ shrink: DadosVenda.sequenciaAgrupamento > 0 ? true : false }}
                            className='inputNovo'
                            id="standard-required"
                            label="Grau Parentesco"
                            variant="standard"
                            name='nomePrincipal'
                            value={DadosVenda.documentoFormatado}
                          />
                        </FormControl>
                      </div>
          </Col>
          <Col min={'140px'} max={'100%'}>
          <div className="inputNovo">
                        <FormControl className="inputNovo" variant="standard" style={{ marginTop: 9 }} >
                          <TextField
                            InputLabelProps={{ shrink: DadosVenda.sequenciaAgrupamento > 0 ? true : false }}
                            className='inputNovo'
                            id="standard-required"
                            label="Beneficiário 1"
                            variant="standard"
                            name='nomePrincipal'
                            value={DadosVenda.documentoFormatado}
                          />
                        </FormControl>
                      </div>
          </Col>
        </Row>

          */<>




            {/*Pergunta 1*/}
            {(meses + DadosVenda.prazo) < 900 ? <>
              <Stack sx={{ width: '100%' }} spacing={2} style={{ marginTop: '15px' }}>
                <div>DECLARAÇÃO PESSOAL DE SAÚDE E ATIVIDADE</div>
              </Stack>
              <Row style={{ marginTop: 10 }}>
                <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                  <div style={{ color: "rgb(110,110,110", marginTop: 10 }}>Encontra-se em plena atividade de trabalho? Se responder não, esclarecer por que não está trabalhando. Se responder não por estar aposentado, informe o motivo e a data da aposentadoria.</div>
                  <RadioGroup style={{ marginBottom: 10 }}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="d1"
                    className="tipoPessoaRadio"
                    onChange={handleChangeCheck}
                    value={DadosVenda.d1}
                  >
                    <FormControlLabel value="S" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Sim" />
                    <FormControlLabel value="N" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Não" />

                  </RadioGroup>
                </Col>
              </Row>
              {DadosVenda.d1 === "N" ? <>
                <Row>
                  <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                    <div className="inputNovo">
                      <FormControl className="inputNovo" variant="standard"  >
                        <TextField
                          inputProps={{ maxLength: 180 }}
                          required
                          className='inputNovo'
                          id="standard-required"
                          label="Justifique"
                          variant="standard"
                          name='d1Justificativa'
                          value={DadosVenda.d1Justificativa.toUpperCase()}
                          onChange={handleChangeInput}
                        />
                      </FormControl>
                    </div>
                  </Col>
                </Row>

              </> : <></>}


              {/*Pergunta 2*/}

              <Row style={{ marginTop: 10 }}>
                <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                  <div style={{ color: "rgb(110,110,110", marginTop: 10 }}>Nos últimos 10 anos, sofreu de alguma doença que exigiu consulta médica, hospitalização, exames, cirurgia ou tratamento, como diabetes, câncer, hipertensão, AIDS ou doenças neurológicas, psiquiátricas, digestivas, renais, hepáticas, circulatórias, pulmonares ou cardíacas? Se sim, informe abaixo o motivo, datas, exames, resultados e dados do médico responsável.</div>
                  <RadioGroup style={{ marginBottom: 10 }}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="d2"
                    className="tipoPessoaRadio"
                    onChange={handleChangeCheck}
                    value={DadosVenda.d2}
                  >
                    <FormControlLabel value="S" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Sim" />
                    <FormControlLabel value="N" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Não" />

                  </RadioGroup>
                </Col>
              </Row>
              {DadosVenda.d2 === "S" ? <>
                <Row>
                  <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                    <div className="inputNovo">
                      <FormControl className="inputNovo" variant="standard"  >
                        <TextField
                          inputProps={{ maxLength: 180 }}
                          required
                          className='inputNovo'
                          id="standard-required"
                          label="Justifique"
                          variant="standard"
                          name='d2Justificativa'
                          value={DadosVenda.d2Justificativa.toUpperCase()}
                          onChange={handleChangeInput}
                        />
                      </FormControl>
                    </div>
                  </Col>
                </Row>
              </> : <></>}

              {/*Pergunta 3*/}

              <Row style={{ marginTop: 10 }}>
                <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                  <div style={{ color: "rgb(110,110,110", marginTop: 10 }}>Tem alguma deficiência de órgão ou sentido, redução de visão (superior a 5 graus ou Dioptrias), audição ou defeito físico em membros ou órgãos? Em caso afirmativo, esclareça o grau de redução.</div>
                  <RadioGroup style={{ marginBottom: 10 }}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="d3"
                    className="tipoPessoaRadio"
                    onChange={handleChangeCheck}
                    value={DadosVenda.d3}
                  >
                    <FormControlLabel value="S" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Sim" />
                    <FormControlLabel value="N" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Não" />

                  </RadioGroup>
                </Col>
              </Row>
              {DadosVenda.d3 === "S" ? <>
                <Row>
                  <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                    <div className="inputNovo">
                      <FormControl className="inputNovo" variant="standard"  >
                        <TextField
                          inputProps={{ maxLength: 180 }}
                          required
                          className='inputNovo'
                          id="standard-required"
                          label="Justifique"
                          variant="standard"
                          name='d3Justificativa'
                          value={DadosVenda.d3Justificativa.toUpperCase()}
                          onChange={handleChangeInput}
                        />
                      </FormControl>
                    </div>
                  </Col>
                </Row>
              </> : <></>}

              {/*Pergunta 4*/}

              <Row style={{ marginTop: 10 }}>
                <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                  <div style={{ color: "rgb(110,110,110", marginTop: 10 }}>Possui outras doenças ou distúrbios não relacionados acima ou está tomando, atualmente, medicamento(s) ou substâncias controladas para qualquer distúrbio, doença ou incômodo (sem contar vitaminas ou ervas medicinais)? Em caso afirmativo, informar nome(s) do medicamento(s) e dose diária.</div>
                  <RadioGroup style={{ marginBottom: 10 }}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="d4"
                    className="tipoPessoaRadio"
                    onChange={handleChangeCheck}
                    value={DadosVenda.d4}
                  >
                    <FormControlLabel value="S" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Sim" />
                    <FormControlLabel value="N" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Não" />

                  </RadioGroup>
                </Col>
              </Row>
              {DadosVenda.d4 === "S" ? <>
                <Row>
                  <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                    <div className="inputNovo">
                      <FormControl className="inputNovo" variant="standard"  >
                        <TextField
                          inputProps={{ maxLength: 180 }}
                          required
                          className='inputNovo'
                          id="standard-required"
                          label="Justifique"
                          variant="standard"
                          name='d4Justificativa'
                          value={DadosVenda.d4Justificativa.toUpperCase()}
                          onChange={handleChangeInput}
                        />
                      </FormControl>
                    </div>
                  </Col>
                </Row>
              </> : <></>}

              {/*Pergunta 5*/}

              <Row style={{ marginTop: 10 }}>
                <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                  <div style={{ color: "rgb(110,110,110", marginTop: 10 }}>Já foi submetido a tratamento médico em regime hospitalar e/ou sofreu intervenção cirúrgica; submeteu-se a exame de cateterismo, ecocardiograma, tomografia computadorizada, ressonância magnética, endoscopia; e/ou a tratamentos radioterápicos, transfusão de sangue ou outro tratamento por período prolongado? Fez Biópsia? Em caso positivo, esclareça.</div>
                  <RadioGroup style={{ marginBottom: 10 }}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="d5"
                    className="tipoPessoaRadio"
                    onChange={handleChangeCheck}
                    value={DadosVenda.d5}
                  >
                    <FormControlLabel value="S" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Sim" />
                    <FormControlLabel value="N" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Não" />

                  </RadioGroup>
                </Col>
              </Row>
              {DadosVenda.d5 === "S" ? <>
                <Row>
                  <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                    <div className="inputNovo">
                      <FormControl className="inputNovo" variant="standard"  >
                        <TextField
                          inputProps={{ maxLength: 180 }}
                          required
                          className='inputNovo'
                          id="standard-required"
                          label="Justifique"
                          variant="standard"
                          name='d5Justificativa'
                          value={DadosVenda.d5Justificativa.toUpperCase()}
                          onChange={handleChangeInput}
                        />
                      </FormControl>
                    </div>
                  </Col>
                </Row>
              </> : <></>}
              {/*Pergunta 6*/}

              <Row style={{ marginTop: 10 }}>
                <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                  <div style={{ color: "rgb(110,110,110", marginTop: 10 }}>Irá ou tem conhecimento de submeter-se a alguma intervenção cirúrgica ou terá que ser hospitalizado nos próximos 12 meses? Caso positivo, esclareça.</div>
                  <RadioGroup style={{ marginBottom: 10 }}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="d6"
                    className="tipoPessoaRadio"
                    onChange={handleChangeCheck}
                    value={DadosVenda.d6}
                  >
                    <FormControlLabel value="S" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Sim" />
                    <FormControlLabel value="N" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Não" />

                  </RadioGroup>
                </Col>
              </Row>
              {DadosVenda.d6 === "S" ? <>
                <Row>
                  <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                    <div className="inputNovo">
                      <FormControl className="inputNovo" variant="standard"  >
                        <TextField
                          inputProps={{ maxLength: 180 }}
                          required
                          className='inputNovo'
                          id="standard-required"
                          label="Justifique"
                          variant="standard"
                          name='d6Justificativa'
                          value={DadosVenda.d6Justificativa.toUpperCase()}
                          onChange={handleChangeInput}
                        />
                      </FormControl>
                    </div>
                  </Col>
                </Row>
              </> : <></>}
              {/*Pergunta 7*/}

              <Row style={{ marginTop: 10 }}>
                <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                  <div style={{ color: "rgb(110,110,110", marginTop: 10 }}>É praticante de esportes (em nível profissional ou amador) como motociclismo, automobilismo, hipismo, rodeio, balonismo, paraquedismo, asa delta, vôo livre, alpinismo, escalada, bungee-jumping, rapel, arborismo, mergulho ou outro esporte considerado de alto risco ou ainda de algum ato ou atividade reconhecidamente perigosa?</div>
                  <RadioGroup style={{ marginBottom: 10 }}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="d7"
                    className="tipoPessoaRadio"
                    onChange={handleChangeCheck}
                    value={DadosVenda.d7}
                  >
                    <FormControlLabel value="S" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Sim" />
                    <FormControlLabel value="N" style={{ width: "300px", height: "30px" }} control={<Radio size="small" sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="Não" />

                  </RadioGroup>
                </Col>
              </Row>
              {DadosVenda.d7 === "S" ? <>
                <Row>
                  <Col style={{ backgroundColor: "rgb(240,240,240" }}>
                    <div className="inputNovo">
                      <FormControl className="inputNovo" variant="standard"  >
                        <TextField
                          inputProps={{ maxLength: 180 }}
                          required
                          className='inputNovo'
                          id="standard-required"
                          label="Justifique"
                          variant="standard"
                          name='d7Justificativa'
                          value={DadosVenda.d7Justificativa.toUpperCase()}
                          onChange={handleChangeInput}
                        />
                      </FormControl>
                    </div>
                  </Col>
                </Row>
              </> : <></>}
            </> : <></>}
          </> : <></>}

        <Row between style={{ marginTop: 35 }}>
          <Col>
            <Form.Group className="mb-3 teste right" as={Col} controlId="formGridEmail">
              <div className="botaoPesquisar">
                <Button variant="primary" type="submit" className="btnPesquisar" onClick={abrirModal}
                  disabled={btnProximo}>
                  <Typography variant="button" gutterBottom>PRÓXIMO</Typography>
                </Button>
              </div>
            </Form.Group>
          </Col>
        </Row>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box sx={style}>
            <Typography>
              <Tabelas1>
                <div className="title2" style={{ color: "var(--blue)" }}><div className='largura'></div><h4>RESUMO DA VENDA</h4> <FiXCircle onClick={handleClose} className='voltar1' /></div>
                <div className="titulo title1" id="alto"><Typography style={{ border: "none", margin: "0" }} gutterBottom><h5>INFORMAÇÕES DO CONSORCIADO</h5></Typography></div>
                <div style={{ border: "solid rgb(236,236,236) 0.5px" }}>
                  <Row>
                    <Col sx={12} sm={4} className="fundo">
                      <b>{DadosVenda.pessoa === "fisica" ? 'CPF' : 'CNPJ'}:</b> {DadosVenda.documentoFormatado}
                    </Col>
                    <Col sx={12} sm={8} className="fundo">
                      <b>NOME:</b> {DadosVenda.nomeCliente}
                    </Col>
                  </Row>
                  <Row>
                    <Col sx={9} sm={9} className="fundo">
                      <b>ENDEREÇO:</b> {DadosVenda.enderecoCobranca === "RES" ? DadosVenda.endereco : DadosVenda.enderecoCom}
                    </Col>
                    <Col sx={3} sm={3} className="fundo">
                      <b>NÚMERO:</b> {DadosVenda.enderecoCobranca === "RES" ? DadosVenda.numero : DadosVenda.numeroCom}
                    </Col>
                  </Row>
                  <Row>
                    <Col sx={12} sm={5} className="fundo">
                      <b>BAIRRO:</b> {DadosVenda.enderecoCobranca === "RES" ? DadosVenda.bairro : DadosVenda.bairroCom}
                    </Col>
                    <Col sx={4} sm={2} className="fundo">
                      <b>APTO:</b> {DadosVenda.enderecoCobranca === "RES" ? DadosVenda.apto : DadosVenda.aptoCom}
                    </Col>
                    <Col sx={4} sm={5} className="fundo">
                      <b>COMPLEMENTO:</b> {DadosVenda.enderecoCobranca === "RES" ? DadosVenda.complemento : DadosVenda.complementoCom}
                    </Col>
                  </Row>
                  <Row>
                    <Col sx={4} sm={3} className="fundo">
                      <b>ESTADO:</b> {DadosVenda.enderecoCobranca === "RES" ? DadosVenda.uf : DadosVenda.estadoCom}
                    </Col>
                    <Col sx={8} sm={6} className="fundo">
                      <b>CIDADE:</b> {DadosVenda.enderecoCobranca === "RES" ? DadosVenda.cidade : DadosVenda.cidadeCom}
                    </Col>
                    <Col sx={12} sm={3} className="fundo">
                      <b>CEP:</b> {DadosVenda.enderecoCobranca === "RES" ? DadosVenda.cep : DadosVenda.cepCom}
                    </Col>
                  </Row>
                </div>
              </Tabelas1>
            </Typography>
            <Typography>
              <Tabelas1>
                <div className="titulo title1" ref={divAlto} style={{ marginTop: "30px" }}><Typography style={{ border: "none", margin: "0" }} gutterBottom><h5>INFORMAÇÕES DO CONTRATO</h5></Typography></div>
                <div style={{ border: "solid rgb(236,236,236) 0.5px" }}>
                  <Row>
                    <Col sx={6} sm={3} className="fundo">
                      <b>DATA VENDA:</b> {DadosVenda.dataAdesaoF}
                    </Col>
                    <Col sx={6} sm={2} className="fundo">
                      <b>GRUPO:</b> {DadosVenda.grupo === '69' ? 'EM FORMAÇÃO' : DadosVenda.grupo}
                    </Col>
                    <Col sx={4} sm={2} className="fundo">
                      <b>PRAZO:</b> {DadosVenda.prazo}
                    </Col>
                    <Col sx={4} sm={3} className="fundo">
                      <b>TAXA ADM TOTAL:</b> {DadosVenda.taxaAdministracao}%
                    </Col>
                    <Col sx={4} sm={2} className="fundo">
                      <b>ADESÃO:</b> {DadosVenda.adesao}%
                    </Col>
                  </Row>
                  <Row>
                    <Col sx={6} sm={3} className="fundo">
                      <b>CÓDIGO BEM:</b> {DadosVenda.codB}
                    </Col>
                    <Col sx={6} sm={5} className="fundo">
                      <b>BEM:</b> {DadosVenda.descricaoBem}
                    </Col>
                    <Col sx={6} sm={4} className="fundo">
                      <b>PARCELA:</b> {DadosVenda.contratarSeguro === 0 ? DadosVenda.valorParcelaFormatado : DadosVenda.valorParcelaComSeguroFormatado}
                    </Col>
                  </Row>
                  <Row>
                    <Col sx={12} sm={6} className="fundo">
                      <b>VALOR CRÉDITO:</b> {DadosVenda.valorCreditoF}
                    </Col>
                    <Col sx={12} sm={6} className="fundo">
                      <b>PRIMEIRA ASSEMBLEIA:</b> {formatData(DadosVenda.primeiraAssembleia)}
                    </Col>
                  </Row>
                </div>

                <div className="titulo title1" style={{ marginTop: "30px" }}><Typography style={{ border: "none", margin: "0" }} gutterBottom><h5>{!carregando ? "FORMA DE PAGAMENTO" : "CONTRATO ESTA SENDO GERADO!"}</h5></Typography></div>
                <div style={{ border: "solid rgb(236,236,236) 0.5px" }}>
                  {!carregando ? <>
                    <div className="testea">
                      <Button onClick={() => tipoPagamento("BOLETO")} style={DadosVenda.tipoPagamento === "RECIBO" ? { backgroundColor: "#677DAF", color: "rgba(255, 255, 255, 0.636)" } : { backgroundColor: "var(--blue)", color: "rgb(255, 255, 255)" }}><Typography variant="button" gutterBottom><FaBarcode style={{ marginRight: 10, alignItems: "center" }} size={20}></FaBarcode>BOLETO</Typography></Button>
                      <Button onClick={() => tipoPagamento("RECIBO")} style={DadosVenda.tipoPagamento === "BOLETO" ? { backgroundColor: "#677DAF", color: "rgba(255, 255, 255, 0.636)", marginLeft: 10 } : { backgroundColor: "var(--blue)", color: "rgb(255, 255, 255)", marginLeft: 10 }} className={DadosVenda.tipoPagamento === "RECIBO" ? "ativo" : ""}><Typography variant="button" gutterBottom><CgNotes style={{ marginRight: 10, alignItems: "center" }} size={20}></CgNotes >RECIBO</Typography></Button>
                    </div>

                    {DadosVenda.tipoPagamento === "RECIBO" ? <>
                      <div>
                        <div style={{ color: "var(--blue)", marginLeft: 20 }}><h5>RECIBO</h5></div>

                        <MRow btMargin>
                          <Col style={{ backgroundColor: "rgb(247,247,247" }}>
                            <FormControl variant="standard" style={{ width: "100%" }} >

                              <TextField
                                style={{ width: "100%", marginTop: 10 }}
                                InputLabelProps={{ shrink: DadosVenda.reciboAdesao > 0 ? true : false }}
                                label="Adesão / Administração"
                                value={DadosVenda.reciboAdesao > 0 ? DadosVenda.reciboAdesao : ""}
                                onChange={handleChangeInput}
                                variant="standard"
                                name="reciboAdesao"
                                id="formatted-numberformat-input"
                                InputProps={{
                                  inputComponent: NumberFormatCustom,
                                }}
                              />
                            </FormControl>
                          </Col>
                        </MRow>
                        <MRow>
                          <Col style={{ backgroundColor: "rgb(247,247,247" }}>
                            <FormControl variant="standard" style={{ width: "100%" }} >
                              <TextField
                                style={{ width: "100%", marginTop: 10 }}
                                InputLabelProps={{ shrink: DadosVenda.reciboPrimeiraParcela > 0 ? true : false }}
                                label="Pagamento da 1º contribuição"
                                value={DadosVenda.reciboPrimeiraParcela > 0 ? DadosVenda.reciboPrimeiraParcela : ""}
                                onChange={handleChangeInput}
                                variant="standard"
                                name="reciboPrimeiraParcela"
                                id="formatted-numberformat-input"
                                InputProps={{
                                  inputComponent: NumberFormatCustom,
                                }}
                              />
                            </FormControl>
                          </Col>
                        </MRow>

                        <MRow>
                          <Col style={{ backgroundColor: "rgb(247,247,247" }}>
                            <FormControl variant="standard" style={{ width: "100%" }} >

                              <TextField
                                style={{ width: "100%", marginTop: 10 }}
                                InputLabelProps={{ shrink: (DadosVenda.reciboPrimeiraParcela > 0 ? DadosVenda.reciboPrimeiraParcela / 100 : 0 + DadosVenda.reciboAdesao > 0 ? DadosVenda.reciboAdesao : 0) > 0 ? true : false }}
                                disabled
                                label="Recebemos a importância supra de"

                                value={(DadosVenda.reciboPrimeiraParcela > 0 ? DadosVenda.reciboPrimeiraParcela : 0) + parseInt(DadosVenda.reciboAdesao > 0 ? DadosVenda.reciboAdesao : 0)}
                                //value={(DadosVenda.reciboPrimeiraParcela+DadosVenda.reciboAdesao) > 0?new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL'}).format(DadosVenda.reciboAdesao):{}}
                                variant="standard"
                                id="formatted-numberformat-input"
                                InputProps={{
                                  inputComponent: NumberFormatCustom,
                                }}
                              />
                            </FormControl>
                          </Col>
                        </MRow>

                        <MRow btMargin>
                          <Col style={{ backgroundColor: "rgb(247,247,247" }}>
                            <FormControl variant="standard" style={{ width: "100%" }} >
                              <TextField
                                style={{ width: "100%", marginTop: 10 }}
                                InputLabelProps={{ shrink: ((DadosVenda.reciboPrimeiraParcela > 0 ? DadosVenda.reciboPrimeiraParcela : 0) + (DadosVenda.reciboAdesao > 0 ? DadosVenda.reciboAdesao : 0)) > 0 ? true : false }}
                                disabled
                                label="Valor por extenso"
                                value={numero.porExtenso(((DadosVenda.reciboPrimeiraParcela > 0 ? DadosVenda.reciboPrimeiraParcela : 0) / 100 + (DadosVenda.reciboAdesao > 0 ? DadosVenda.reciboAdesao : 0) / 100), numero.estilo.monetario).toUpperCase()}
                                //value={(DadosVenda.reciboPrimeiraParcela+DadosVenda.reciboAdesao) > 0?new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL'}).format(DadosVenda.reciboAdesao):0}
                                variant="standard"
                                id="formatted-numberformat-input"
                              />
                            </FormControl>
                          </Col>
                        </MRow></div>
                    </> : <></>}

                    {DadosVenda.tipoPagamento !== "" ? <>

                      <div className="teste">
                        <div className="titulo title1" style={{ marginTop: "30px" }}><Typography style={{ border: "none", margin: "0" }} gutterBottom><h5>ASSINATURA DO CONTRATO</h5></Typography></div>
                        <div style={{ border: "solid rgb(236,236,236) 0.5px" }}>
                          <div className="testea">
                            <Button onClick={() => tipoAssinatura("MANUAL")} style={DadosVenda.tipoAssinatura === "DIGITAL" ? { backgroundColor: "#677DAF", color: "rgba(255, 255, 255, 0.636)" } : { backgroundColor: "var(--blue)", color: "rgb(255, 255, 255)" }}><Typography variant="button" gutterBottom><FaFileSignature style={{ marginRight: 10, alignItems: "center" }} size={20}></FaFileSignature>ASSINATURA MANUAL</Typography></Button>
                            <Button onClick={() => tipoAssinatura("DIGITAL")} style={DadosVenda.tipoAssinatura === "MANUAL" ? { backgroundColor: "#677DAF", color: "rgba(255, 255, 255, 0.636)", marginLeft: 10 } : { backgroundColor: "var(--blue)", color: "rgb(255, 255, 255)", marginLeft: 10 }} className={DadosVenda.tipoPagamento === "RECIBO" ? "ativo" : ""}><Typography variant="button" gutterBottom><FaCloud style={{ marginRight: 10, alignItems: "center" }} size={20}></FaCloud >ASSINATURA DIGITAL</Typography></Button>
                          </div>
                          {DadosVenda.tipoAssinatura === "MANUAL" ? <>
                            <MRow>
                              <Col style={{ backgroundColor: "rgb(247,247,247" }}>
                                <FormControl variant="standard" style={{ width: "100%" }} >
                                  <TextField
                                    style={{ width: "100%", marginTop: 10 }}
                                    InputLabelProps={{ shrink: DadosVenda.emailGeral.length > 0 ? true : false }}
                                    label="Digite um email para enviar contrato"
                                    value={DadosVenda.emailGeral}
                                    onChange={handleChangeInput2}
                                    variant="standard"
                                    name="emailAssinaturaManual"
                                    id="formatted-numberformat-input"
                                  />
                                </FormControl>
                              </Col>
                            </MRow>
                          </> : <></>}
                        </div>
                      </div>

                      <div className="testeb" id="baixo" ref={testRef}>
                        <Button
                          disabled={DadosVenda.tipoAssinatura ? false : true}
                          style={{ backgroundColor: "var(--blue)" }}
                          onClick={efetivarVenda}
                        >
                          <Typography variant="button" gutterBottom>EFETIVAR VENDA</Typography>
                        </Button>
                      </div>
                    </> : <>
                    </>}
                  </> : <>
                    <div className="testea">
                      <Box sx={{ display: 'flex' }} style={{}}>
                        <CircularProgress />
                      </Box>
                    </div>
                  </>}
                </div>
              </Tabelas1>
            </Typography>
          </Box>
        </Modal>
      </Container>
    </>
  )
}